import { useSuspenseQuery } from "@tanstack/react-query";
import { type Task } from "@/types/task";

const fetchTask = async (taskableType: string): Promise<Task> => {
  const response = await fetch(`/tasks/${encodeURIComponent(taskableType)}`);
  return response.json();
};

export default function useTask(taskableType: string) {
  return useSuspenseQuery<Task>({
    queryKey: ["task", taskableType],
    queryFn: () => fetchTask(taskableType),
    staleTime: 0,
    refetchOnMount: true,
  });
}
